<style lang="less" rel="stylesheet/less" scoped>
html *,
body * {
  outline: none;
}
.keyboard img {
  -webkit-user-select: none;
  pointer-events: none;
}

.keyboard a {
  -webkit-touch-callout: none;
}
input {
  border: none;
}
.hide {
  display: none;
}

/* 键盘公共 */

.keyboard {
  position: absolute;
  bottom: 184px;
  left: 40%;
  width: 605px;
  height: 309px;
  background: #333;
  color: #333333;
  overflow: hidden;
  z-index: 12000;
  border-radius: 4px;
}
.keyboard_xiaoxue {
  height: 264px;
}
.kb_inputs {
  background: #1f1f1e;
  height: 61px;
  margin-top: 8px;
  margin-left: 8px;
  margin-right: 8px;
  border-radius: 5px;
  position: relative;
  text-align: left;
}

.kb_cons {
  margin-top: 6px;
  margin-left: 8px;
  margin-right: 8px;
  font-size: 0;
  overflow: hidden;
}

.kb_input {
  width: 360px;
  height: 32px;
  background: #fff;
  border-radius: 3px;
  margin-top: 15px;
  margin-left: 10px;
  line-height: 32px;
  text-align: left;
  font-size: 16px;
  padding: 0 5px;
  color: #222222;
}

.kb_input input {
  width: 100%;
  height: 100%;
  height: 61px;
  background: rgba(0, 0, 0, 0);
  border: none;
  color: #fff;
  text-align: center;
  font-size: 16px;
}

.kb_inputBox {
  display: inline-block;
  color: #dcdcdc;
  width: 371px;
  text-align: left;
}

.kb_but {
  float: right;
  width: 59px;
  background: #505050;
  color: #dcdcdc;
  border: none;
  border-radius: 4px;
  height: 53px;
  padding: 0;
  margin-top: 4px;
  margin-right: 4px;
}
.kb_but_cur {
  background: #108a99;
  color: #fff;
}
.kb_switch {
  width: 61px;
  background: #505050;
  height: 229px;
  border-radius: 4px;
  float: left;
  position: relative;
}
.kb_switch span {
  display: block;
  width: 53px;
  height: 40px;
  border-radius: 4px;
  text-decoration: none;
  margin-top: 4px;
  font-size: 16px;
  position: absolute;
  top: 1px;
  left: 4px;
  background: #dcdcdc;
  z-index: 1;
  transition-duration: 0.2s;
}
.kb_switch a {
  display: block;
  width: 53px;
  height: 40px;
  color: #fff;
  line-height: 40px;
  text-align: center;
  border-radius: 4px;
  text-decoration: none;
  margin: 0 auto;
  margin-top: 4px;
  font-size: 16px;
  z-index: 2;
  position: relative;
  transition-duration: 0.2s;
}

.kb_switch a.cur {
  color: #222222;
}
.kb_left_mark {
  width: 61px;
  height: 229px;
  border-radius: 4px;
  float: left;
}

.kb_left_mark a {
  display: block;
  background: #505050;
  width: 53px;
  height: 40px;
  color: #fff;
  line-height: 40px;
  text-align: center;
  border-radius: 4px;
  text-decoration: none;
  margin: 0 auto;
  margin-bottom: 7px;
  font-size: 16px;
  position: relative;
}
.anBox {
  transition-duration: 0.5s;
}
.kb_con_div {
  height: 234px;
}
.kb_left_mark a:hover {
  background: #dcdcdc;
  color: #222222;
}
.kb_left_mark a:active .clickbg {
  display: block;
}
.kb_con {
  float: left;
  width: 466px;
  height: 234px;
}
.kb_con_chuzhong {
  overflow: hidden;
}
.kb_con a {
  float: left;
  width: 40px;
  height: 40px;
  background: #717171;
  color: #fff;
  line-height: 40px;
  text-align: center;
  border-radius: 4px;
  margin-left: 6px;
  margin-bottom: 7px;
  text-decoration: none;
  box-shadow: 0px 1px 0px #000;
  font-size: 20px;
  position: relative;
}

.kb_tools {
  width: 62px;
  float: right;
}

.kb_tools a {
  display: block;
  width: 62px;
  height: 40px;
  background: #505050;
  color: #fff;
  line-height: 40px;
  text-align: center;
  border-radius: 4px;
  text-decoration: none;
  margin: 0 auto;
  margin-bottom: 7px;
  font-size: 16px;
}

.kb_tools .kb_tool_fs {
  background: url("../../../assets/img/keyboard/fs_def.png") center #505050
    no-repeat;
  background-size: 22px;
}
.kb_tools_xiaoxue .kb_tool_fs {
  height: 87px;
  background: url("../../../assets/img/keyboard/fs_def.png") center #505050
    no-repeat;
  background-size: 22px;
}

.kb_tools .kb_tool_genhao {
  background: url("../../../assets/img/keyboard/genhao_def.png") center #505050
    no-repeat;
  background-size: 25px;
}

.kb_tools .kb_tool_pingfang {
  background: url("../../../assets/img/keyboard/pingfang_def.png") center
    #505050 no-repeat;
  background-size: 27px;
}

.kb_tools .kb_tool_del {
  height: 87px;
  background: url("../../../assets/img/keyboard/del_def.png") center #505050
    no-repeat;
  background-size: 23px;
}
.kb_tools .kb_tool_del:active {
  background-color: #fff;
}

.kb_tools a.cur:nth-child(1) {
  background: url("../../../assets/img/keyboard/fs_cur.png") center #fff
    no-repeat;
  background-size: 22px;
}

.kb_tools a.cur:nth-child(2) {
  background: url("../../../assets/img/keyboard/genhao_cur.png") center #fff
    no-repeat;
  background-size: 25px;
}

.kb_tools a.cur:nth-child(3) {
  background: url("../../../assets/img/keyboard/pingfang_cur.png") center #fff
    no-repeat;
  background-size: 27px;
}
.kb_tools a.cur {
  background: #fff;
}
.k-btn:hover {
  background: #dcdcdc;
  color: #222222;
}

.k-btn:active {
  background: #dcdcdc;
  color: #222222;
}
.k-btn:active .clickbg {
  display: block;
}
.k-btn.k-btn_space{
  width: 454px;
}
.kb_tools .kb_tool_del:active {
  height: 87px;
  background: url("../../../assets/img/keyboard/del_def.png") center #fff
    no-repeat;
  background-size: 23px;
}

.k-f-zs {
  float: left;
  width: 80px;
  height: 22px;
  line-height: 22px;
  border-radius: 3px;
  background: #505050;
  padding: 0 5px;
  margin-top: 20px;
  overflow: hidden;
  margin-left: 10px;
  color: #fff;
  font-size: 16px;
}
.k-input-fraction {
  margin-top: 4px;
  display: inline-block;
}
.k-f-fs {
  float: left;
  margin-left: 5px;
}

.k-f-fz,
.k-f-fm {
  width: 70px;
  height: 22px;
  line-height: 22px;
  border-radius: 3px;
  background: #505050;
  padding: 0 5px;
  overflow: hidden;
  display: inherit;
  color: #fff;
  font-size: 16px;
}

.k-f-line {
  width: 70px;
  height: 2px;
  background: #717171;
  margin: 3px 0;
  padding: 0 5px;
}

.kb_input_genhao {
  width: 93px;
  position: relative;
  height: 35px;
  background: url("../../../assets/img/keyboard/genhao_bg.png") no-repeat;
  background-size: 93px;
  margin-top: 14px;
  margin-left: 10px;
}
.kb_input_genhao input {
  position: absolute;
  width: 60px;
  height: 24px;
  top: 8px;
  left: 22px;
  border-radius: 3px;
  padding: 0 5px;
  font-size: 16px;
  background: #fff;
  color: #000;
}

.kb_input_pingfang {
  position: relative;
  height: 61px;
  width: 150px;
  display: block;
}
.pingfang_input1 {
  position: absolute;
  width: 60px;
  height: 24px;
  border-radius: 3px;
  top: 24px;
  left: 10px;
  padding: 0 5px;
  background: #505050;
  color: #fff;
  font-size: 16px;
  line-height: 24px;
}
.pingfang_input2 {
  position: absolute;
  width: 28px;
  height: 24px;
  border-radius: 3px;
  top: 12px;
  left: 85px;
  padding: 0 5px;
  background: #505050;
  color: #fff;
  font-size: 16px;
  line-height: 24px;
}
.pingfang-active {
  background: #fff;
  position: relative;
  color: #000;
}

/*按键动画*/
.clickbg {
  width: 86px;
  height: 108px;
  background: url("../../../assets/img/keyboard/clickbg.png") no-repeat;
  display: block;
  position: absolute;
  top: -65px;
  left: -11px;
  background-size: 86px;
  color: #222222;
  text-align: center;
  display: none;
  animation: ssssd 0.2s;
  transform-origin: bottom;
  z-index: 999999;
}
@keyframes ssssd {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.clickbg em {
  display: block;
  font-style: normal;
}
.clickbg em:nth-child(1) {
  text-decoration: none;
  font-size: 30px;
  margin-top: 14px;
}
.clickbg em:nth-child(2) {
  text-decoration: none;
  font-size: 20px;
  margin-top: 11px;
}
.tool_left {
  width: 8px;
  height: 14px;
  background: url("../../../assets/img/keyboard/left.png") no-repeat;
  position: absolute;
  top: 24px;
  right: 135px;
  background-size: 100%;
}
.tool_right {
  width: 8px;
  height: 14px;
  background: url("../../../assets/img/keyboard/right.png") no-repeat;
  position: absolute;
  top: 24px;
  right: 90px;
  background-size: 100%;
}

.k-f-active {
  background: #fff;
  position: relative;
  color: #000;
}
</style>
<template>
    <div :class="['keyboard', keyboard_type=='xx'? 'keyboard_xiaoxue':'']" >
        <div class="kb_inputs">
            <div class="tool_left cursor" @click="set_input_guangbiao('left')"></div>
            <div class="tool_right cursor"  @click="set_input_guangbiao('right')"></div>
            <div class="kb_inputBox">
                <input type="text"  @keydown="aaa" v-show="onInput_type=='number'"  autofocus ref="number" v-model="number"   @click="inputClick('number')" class="kb_input kb_input_el kb_input_text"   maxlength="12">
                <div v-show="onInput_type=='fenshu'" class="k-input-fraction clearfix kb_input_el kb_input_fs">
                    <input type="text"  @keydown="aaa" v-model="zhengshu" ref="zhengshu" @click="inputClick('zhengshu')"  :class="['k-f-zs',value_type=='zhengshu'?'k-f-active':'']" maxlength="12">
                    <div class="k-f-fs">
                        <input type="text"  @keydown="aaa"  ref="fenzi"  @click="inputClick('fenzi')"  v-model="fenzi" :class="['k-f-fz',value_type=='fenzi'?'k-f-active':'']" maxlength="12">
                        <div class="k-f-line"></div>
                        <input type="text"  @keydown="aaa"  ref="fenmu" vo-focus autofocus  @click="inputClick('fenmu')" v-model="fenmu"  :class="['k-f-fm',value_type=='fenmu'?'k-f-active':'']" maxlength="12">
                    </div>
                </div>
                <div v-show="onInput_type=='genhao'" class="kb_input_genhao kb_input_el">
                   <input  type="text" name="" ref="beikaifang" @keydown="aaa" v-model="beikaifang" @click="inputClick('beikaifang')" class="genhao_input" maxlength="12">
                    <div class="genhao_bg"></div>
                </div>
                <div  v-show="onInput_type=='pingfang'" class="kb_input_pingfang kb_input_el">
                    <div ></div>
                    <input  type="text" name="" ref="dishu" @keydown="aaa" @click="inputClick('dishu')" v-model="dishu"    :class="['pingfang_input1',value_type=='dishu'?'k-f-active':''] " maxlength="12">
                    <input  type="text" name=""   ref="mi" @keydown="aaa" @click="inputClick('mi')" :class="['pingfang_input2',value_type=='mi'?'k-f-active':'']" v-model="mi"  maxlength="12">
                </div>
            </div>
            <button :class="['kb_but', result==''? '':'kb_but_cur','cursor']" @click="sure()" >确定</button>
        </div>
        <div class="kb_cons">
            <div class="kb_switch" v-if="keyboard_type=='cz'">
                <span class="cur" :style="'transform:translateY('+distance+'px)'"></span>
                 <a href="javascript:;" @click="changeLeftType('number',0,0)"  :class="[this.leftType=='number'?'cur':'']" >123</a>
                <a href="javascript:;"  @click="changeLeftType('insignia',43,230)" :class="[this.leftType=='insignia'?'cur':'']" >符号</a>
                <a href="javascript:;"  @click="changeLeftType('ABC',86,465)" :class="[this.leftType=='ABC'?'cur':'']" >ABC</a>
                <a href="javascript:;"   @click="changeLeftType('abc',129,700)" :class="[this.leftType=='abc'?'cur':'']">abc</a>


            </div>
            <div class="kb_left_mark"  v-if="keyboard_type=='xx'">
                <a href="javascript:;"  @click="importValue('-')">-</a>
                <a href="javascript:;"   @click="importValue(':')">:</a>
                <a href="javascript:;" @click="importValue(',')">,</a>
                <a href="javascript:;" @click="importValue('=')">=</a>
            </div>
            <div class="kb_con ">
                <div class="kb_con_xiaoxue" v-if="keyboard_type=='xx'">
                    <div class="kb_num"  v-if="input_type=='number'" >
                        <a class="k-btn" href="javascript:;"
                        @click="importValue(item)"  v-for="(item,index) in numberList" :key="index">{{item}}</a>

                    </div>
                    <div class="kb_ABC"   v-if="input_type=='abc'" >
                       <a class="k-btn" href="javascript:;"
                        @click="importValue(item)"  v-for="(item,index) in upperList" :key="index">{{item}}</a>

                    </div>
                </div>
                <div class="anBox kb_con_chuzhong"  v-if="keyboard_type=='cz'" :style="'transform:translateY(-'+distance1+'px)'">
                <div class="kb_num kb_con_div">
                       <a class="k-btn" href="javascript:;"
                        @click="importValue(item)"  v-for="(item,index) in numberList_cz" :key="index">{{item}}</a>

                </div>%0·-:,
                <div class="kb_insignia kb_con_div">

                  <a class="k-btn" href="javascript:;"
                        @click="importValue(item)"  v-for="(item,index) in symbolList" :key="index">{{item}}</a>

                </div>
                <div class="kb_ABC kb_con_div">
                   <a :class="['k-btn',item==' '?'k-btn_space':'']" href="javascript:;"
                        @click="importValue(item)"  v-for="(item,index) in upperList_cz" :key="index">{{item==' '?'空格':item}}</a>

                </div>
                 <div class="kb_abc kb_con_div">
                   <a :class="['k-btn',item==' '?'k-btn_space':'']" href="javascript:;"
                        @click="importValue(item)"  v-for="(item,index) in lowerList_cz" :key="index">{{item==' '?'空格':item}}</a>

                </div>
                </div>
            </div>
            <div class="kb_tools kb_tools_chuzhong"  v-if="keyboard_type=='cz'">
                <a href="javascript:;"  @click="changetype('fenshu')"  :class="['kb_tool', 'kb_tool_fs',onInput_type=='fenshu'?'cur':'']" ></a>
                <a href="javascript:;" :class="['kb_tool', 'kb_tool_genhao',onInput_type=='genhao'?'cur':'']"  @click="changetype('genhao')" ></a>
                <a href="javascript:;" :class="['kb_tool', 'kb_tool_pingfang',onInput_type=='pingfang'?'cur':'']"  @click="changetype('pingfang')" ></a>
                <a href="javascript:;" class="kb_tool_del"  @click="del"  data-value="del"></a>
            </div>
            <div class="kb_tools kb_tools_xiaoxue"  v-if="keyboard_type=='xx'">
                <a  href="javascript:;"  @click="changetype('fenshu')"  :class="['kb_tool','kb_tool_fs',onInput_type=='fenshu'?'cur':'']" ></a>
                <a  href="javascript:;"  @click="del"  class="kb_tool_del" ></a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      // keyboard_type: "cz", //键盘类型  xx:小学键盘  cz:初中键盘
      // input_type: "", //键盘输入类型 ABC:英文大写键盘  adc:英文小写键盘  number:数字键盘  all:初中键盘
      onInput_type: "number", //正在输入的输入区域类型 number:数字 gnhao：根号  pingfang:平方 fenshu:分数
      value_type: "number", //正在输入内容的输入框类型 number：数字
      leftType: "number",
      distance: 0,
      distance1: 0,
      fenzi: "",
      fenmu: "",
      dishu: "",
      mi: "",
      beikaifang: "",
      kaifang: "",
      number: "",
      zhengshu: "",
      numberList: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "%", "0", "."],
      upperList: ["A", "B", "C", "D", "E", "F", "M", "N", "O", "x", "y", "z"],
      lowerList: ["a", "b", "c", "d", "e", "f", "m", "n", "o", "x", "y", "z"],
      numberList_cz: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "%",
        "0",
        ".",
        "-",
        ":",
        ","
      ],
      upperList_cz: [
        // "A",
        // "B",
        // "C",
        // "D",
        // "E",
        // "F",
        // "G",
        // "M",
        // "N",
        // "P",
        // "Q",
        // "O"
        'Q','W','E','R','T','Y','U','I','O','P','A','S','D','F','G','H','J','K','L',"'",'Z','X','C','V','B','N','M',' '
      ],
      // lowerList_cz: ["a", "b", "c", "d", "m", "n", "x", "y", "z", "k", "l"],
      lowerList_cz: ['q','w','e','r','t','y','u','i','o','p','a','s','d','f','g','h','j','k','l',"'",'z','x','c','v','b','n','m',' '],
      symbolList: [
        "＋",
        "×",
        "÷",
        "＞",
        "＜",
        "(",
        "≥",
        "≤",
        ")",
        "π",
        "≠",
        "±"
      ]
    };
  },
  props: {
    input_type: {
      type: String,
      required: false,
      default: "number"
    }
  },
  computed: {
    allString() {
      if (this.keyboard_type == "xx") {
        if (this.input_type == "number") {
          return "-:,=123456789%0.";
        } else if (this.input_type == "abc") {
          // return "ABCDEFMNOxyz-:,=";
          return "QWERTYUIOPASDFGHJKLZXCVBNMqwertyuiopasdfghjklzxcvbnm'-:,= ";
        }
      } else if (this.keyboard_type == "cz") {
        // return "1234567890%.-:,＋×÷＞＜()≥≤π≠±ABCDEFGMNPQOabcdmnxyzkl";
        return "1234567890%.-:,＋×÷＞＜()≥≤π≠±QWERTYUIOPASDFGHJKLZXCVBNMqwertyuiopasdfghjklzxcvbnm' ";
      }
    },
    result() {
      this.updateValue();
      return (
        this.zhengshu +
        this.number +
        this.fenzi +
        this.fenmu +
        this.dishu +
        this.mi +
        this.kaifang +
        this.beikaifang
      );
    },
    keyboard_type() {
      if (this.input_type == "number" || this.input_type == "abc") {
        return "xx";
      } else if (this.input_type == "all") {
        return "cz";
      }
    }
  },
  watch: {
    number(val, val1) {
      if (!this.allString.includes(val.slice(val.length - 1))) {
        this.number = val1;
      }
    },
    fenzi(val, val1) {
      if (!this.allString.includes(val.slice(val.length - 1))) {
        this.fenzi = val1;
      }
    },
    fenmu(val, val1) {
      if (!this.allString.includes(val.slice(val.length - 1))) {
        this.fenmu = val1;
      }
    },
    zhengshu(val, val1) {
      if (!this.allString.includes(val.slice(val.length - 1))) {
        this.fenmu = val1;
      }
    },
    beikaifang(val, val1) {
      if (!this.allString.includes(val.slice(val.length - 1))) {
        this.beikaifang = val1;
      }
    },
    dishu(val, val1) {
      if (!this.allString.includes(val.slice(val.length - 1))) {
        this.dishu = val1;
      }
    },
    mi(val, val1) {
      if (!this.allString.includes(val.slice(val.length - 1))) {
        this.mi = val1;
      }
    }
  },
  mounted() {
    this.$refs[this.value_type].focus();
    this.$emit("changeinput", { type: "number", list: [""] });
  },
  methods: {
    inputClick(data) {
      this.value_type = data;
    },
    sure() {
      this.$root.eventHub.$emit("sure");
    },
    changeLeftType(value, distance, distance1) {
      this.distance = distance;
      this.distance1 = distance1;
      this.leftType = value;
    },
    aaa(e) {
      e = e || window.event;
      let keycode = e.keyCode || e.which || e.charCode;
      let keyVal = String.fromCharCode(e.which);
      if (
        !(
          this.allString.includes(keyVal) === true ||
          keycode == 37 ||
          keycode == 38 ||
          keycode == 39 ||
          keycode == 40 ||
          keycode == 110 ||
          (keycode >= 96 && keycode <= 105) ||
          keycode == 8
        )
      ) {
        if (window.navigator.userAgent.toLowerCase().indexOf("msie") >= 1) {
          e.returnValue = false; //ie 禁止键盘输入
        } else {
          e.preventDefault(); //fire fox 禁止键盘输入
        }
      }
    },
    //重置所有输入框的内容为空
    resetValue() {
      this.fenzi = "";
      this.fenmu = "";
      this.zhengshu = "";
      this.mi = "";
      this.dishu = "";
      this.beikaifang = "";
      this.kaifang = "";
      this.number = "";

    },
    resetKeyboard(){
      this.resetValue();
      this.onInput_type = "number";
    },
    //切换功能键按钮类型
    changetype(data) {
      this.resetValue();
      if (this.onInput_type == data) {
        this.onInput_type = "number";
        this.value_type = "number";
      } else {
        if (data == "fenshu") {
          this.onInput_type = data;
          this.value_type = "fenmu";
        } else if (data == "genhao") {
          this.onInput_type = data;
          this.value_type = "beikaifang";
        } else if (data == "pingfang") {
          this.onInput_type = data;
          this.value_type = "dishu";
        }
      }
      this.$nextTick(() => {
        this.$refs[this.value_type].focus();
      });
    },

    //从光标位置开始向前删除输入如框内容
    delvalue(value, num) {
      if (num == 0) {
        return value;
      }
      let str1 = value.slice(0, num - 1);
      let str2 = value.slice(num);
      return str1 + str2;
    },
    //键盘删除键
    del() {
      let ele = this.$refs[this.value_type];
      let num = this.getCursortPosition(ele); //input光标位置
      switch (this.value_type) {
        case "number":
          this.number = this.delvalue(this.number, num);
          break;
        case "zhengshu":
          this.zhengshu = this.delvalue(this.zhengshu, num);
          break;
        case "fenzi":
          this.fenzi = this.delvalue(this.fenzi, num);
          break;
        case "fenmu":
          this.fenmu = this.delvalue(this.fenmu, num);
          break;
        case "dishu":
          this.dishu = this.delvalue(this.dishu, num);
          break;
        case "mi":
          this.mi = this.delvalue(this.mi, num);
          break;
        case "beikaifang":
          this.beikaifang = this.delvalue(this.beikaifang, num);
          break;
      }
      this.$nextTick(() => {
        this.setCaretPosition(ele, num - 1);
      });
    },
    //更新输入的内容并返回，保持填空题输入区域同步
    updateValue() {
      if (this.onInput_type == "number") {
        this.$emit("changeinput", {
          type: this.onInput_type,
          list: [this.number]
        });
      } else if (this.onInput_type == "fenshu") {
        if (this.zhengshu != "") {
          this.$emit("changeinput", {
            type: this.onInput_type,
            list: [this.fenzi, this.fenmu, this.zhengshu]
          });
        } else {
          this.$emit("changeinput", {
            type: this.onInput_type,
            list: [this.fenzi, this.fenmu]
          });
        }
      } else if (this.onInput_type == "genhao") {
        this.$emit("changeinput", {
          type: this.onInput_type,
          list: [ this.beikaifang,'']
        });
      } else if (this.onInput_type == "pingfang") {
        this.$emit("changeinput", {
          type: this.onInput_type,
          list: [this.dishu, this.mi]
        });
      }
    },
    //键盘数字按钮
    importValue(value) {
      console.log(865,value,this.input_type,this.keyboard_type)
      if (this[this.value_type].length == 12) return;
      if (!this.allString.includes(value)) {
        return;
      }
      switch (this.value_type) {
        case "number":
          this.number += value;
          break;
        case "zhengshu":
          this.zhengshu += value;
          break;
        case "fenzi":
          this.fenzi += value;
          break;
        case "fenmu":
          this.fenmu += value;
          break;
        case "dishu":
          this.dishu += value;
          break;
        case "mi":
          this.mi += value;
          break;
        case "kaifang":
          this.kaifang += value;
          break;
        case "beikaifang":
          this.beikaifang += value;
          break;
      }
      this.$refs[this.value_type].focus();
    },
    set_input_guangbiao(type) {
      let ele = this.$refs[this.value_type];
      if (type == "left") {
        var tmpPo = this.getCursortPosition(ele); //input光标位置
        this.setCaretPosition(ele, tmpPo - 1);
      }
      if (type == "right") {
        var tmpPo = this.getCursortPosition(ele); //input光标位置
        this.setCaretPosition(ele, tmpPo + 1);
      }
      //
    },

    // 获取光标位置
    getCursortPosition(ctrl) {
      var CaretPos = 0; // IE
      if (document.selection) {
        ctrl.focus();
        var Sel = document.selection.createRange();
        Sel.moveStart("character", -ctrl.value.length);
        CaretPos = Sel.text.length;
      } else if (ctrl.selectionStart || ctrl.selectionStart == "0")
        // 兼容傻逼火狐
        CaretPos = ctrl.selectionStart;
      return CaretPos;
    },
    // 设置光标位置
    setCaretPosition(element, pos) {
      if (element.setSelectionRange) {
        element.focus();
        element.setSelectionRange(pos, pos);
      } else if (element.createTextRange) {
        var range = element.createTextRange();
        range.collapse(true);
        range.moveEnd("character", pos);
        range.moveStart("character", pos);
        range.select();
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/bussiness/video/keyboard.vue